import React from 'react'
import ProfileHeader from '../components/Organisms/Headers/ProfileHeader'
import ProfileForm from '../components/Organisms/Forms/ProfileForm'

const Profile = () => {
  return (
    <div className='ed-grid'>
      <div className='s-column s-to-center m-60 s-flex-gap-32px'>
        <ProfileHeader />
        <ProfileForm />
      </div>
    </div>
  )
}

export default Profile
